import { getCaptionsFromConfig } from 'components/VideoTemplateEditor/state';
import { getBaseCaptionsOverride } from 'utils/embed/captions/utils';

import applyMigrations from '../../../../migrations';
import { createCaptionsTextOverlay } from '../../../../style-captions-utils';
import { createDefaultOverlayV2 } from '../../../../style-import-utils';
import { TextOverlayV2 } from '../../../../types';
import { ResetPresetVariant } from './types';

const getCaptionsClipBaseOverlay = (aspectRatio: number): TextOverlayV2 => {
  const captionsOverride = getCaptionsFromConfig(
    getBaseCaptionsOverride(aspectRatio, false),
  );
  return applyMigrations(
    createCaptionsTextOverlay(aspectRatio, captionsOverride),
  );
};

const getCaptionsFullEpOverlay = (aspectRatio: number): TextOverlayV2 => {
  const captionsOverride = getCaptionsFromConfig(
    getBaseCaptionsOverride(aspectRatio, true),
  );
  return applyMigrations(
    createCaptionsTextOverlay(aspectRatio, captionsOverride),
  );
};

const getTextOverlay = (aspectRatio: number): TextOverlayV2 => {
  return applyMigrations(createDefaultOverlayV2(aspectRatio));
};

export const getStyleResetOverlay = (
  variant: ResetPresetVariant,
  aspectRatio: number,
): TextOverlayV2 | null => {
  switch (variant) {
    case 'captions-clip':
      return getCaptionsClipBaseOverlay(aspectRatio);
    case 'captions-full-ep':
      return getCaptionsFullEpOverlay(aspectRatio);
    case 'text':
      return getTextOverlay(aspectRatio);
    default:
      return null;
  }
};
